import React, { useEffect, useCallback, useMemo } from 'react';
import { compose } from 'redux';
import i18n from 'i18n';
import qs from 'querystring';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { transform, isEmpty } from 'lodash';
import scaleSize from 'utils/scale-size';
import { fetchSearch, loadExtraSearchItems, resetSearchData } from 'actions/search-all';
import { selectCategories } from 'reducers/search-all/selectors';
import withBackSupport from 'components/HOCs/withBackSupport';
import withMouseControls from 'components/HOCs/withMouseControls';
import withScrollHack from 'components/HOCs/withScrollHack';
import useContentNavigation from 'hooks/useContentNavigation';
import useOnNavigationBack from 'hooks/useOnNavigationBack';
import BackButton from 'components/BackButton';
import CustomCollection from 'components/CustomCollection';
import { StyledPageLayout } from './StyledComponents';

const SearchAllPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const locationParams = useMemo(
    () => qs.parse(decodeURIComponent(history.location.search).replace('?', '')),
    [history],
  );
  const title = i18n.t('search.searchResults');
  const categories = useSelector(selectCategories);
  // transform object to array
  const collections = useMemo(() => {
    return transform(categories, (result, value, key) => result.push({ ...value, id: key }), [])
      .filter((category) => !isEmpty(category.content))
      .map((category) => {
        const title = i18n.t(`search.categories.${category.id}`);
        return { ...category, title };
      });
  }, [categories]);

  const onContentEnter = useContentNavigation();

  const onContentEnterWarpper = useCallback(
    (item, index, focusBackConfig) => {
      const analyticsParams = {
        eventGroup: 'search',
        eventName: `click`,
        eventValue: `search request="${locationParams.query}";search result=yes;numberEl=${
          index + 1
        };`,
      };
      onContentEnter(item, focusBackConfig, analyticsParams);
    },
    [onContentEnter, locationParams],
  );

  const loadExtraItems = useCallback(
    (params) => dispatch(loadExtraSearchItems(params)),
    [dispatch],
  );

  useOnNavigationBack(() => dispatch(resetSearchData()));

  useEffect(() => {
    if (isEmpty(categories)) dispatch(fetchSearch(locationParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StyledPageLayout>
      <BackButton onEnter={history.goBack} />
      {!isEmpty(collections) && (
        <CustomCollection
          title={title}
          collections={collections}
          onContentEnter={onContentEnterWarpper}
          focusedCollectionId={locationParams.category}
          startListScrollIndex={1}
          loadExtraItems={loadExtraItems}
          top={scaleSize(55)}
        />
      )}
    </StyledPageLayout>
  );
};

export default compose(withMouseControls, withBackSupport, withScrollHack)(SearchAllPage);
